export const config = {
  eventGroup: 'jx0_fly_pc_20250508',
  name: '《剑侠情缘零》分流页PC端',
  identify: 'jx0',
  eventTags: ['jx0', 'fly', 'pc']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 上报选中的位置：顶部通栏、首页按钮
     */
    clickGoReservation: function(title) {
      report({
        eventName: 'click_go_reservation',
        eventDescription: '点击前往预约',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [status] - 成功：success 失败：fail
     * @param {string} [statusReason] - 返回原因
     */
    clickGainCode: function(status, statusReason) {
      report({
        eventName: 'click_gain_code',
        eventDescription: '点击获取验证码',
        eventDataValue: {
          status: status,
          status_reason: statusReason
        },
        types: {
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 上报选中的系统：安卓、苹果、鸿蒙
     * @param {string} [status] - 成功：success  失败：fail
     * @param {string} [statusReason] - 返回原因
     */
    clickReservationNow: function(title, status, statusReason) {
      report({
        eventName: 'click_reservation_now',
        eventDescription: '点击立即预约',
        eventDataValue: {
          title: title,
          status: status,
          status_reason: statusReason
        },
        types: {
          title: checkTypeHOF('string'),
          status: checkTypeHOF('string'),
          status_reason: checkTypeHOF('string')
        }
      });
    },
    clickGoReservationSaoma: function() {
      report({
        eventName: 'click_go_reservation_saoma',
        eventDescription: '点击扫码预约'
      });
    },
    clickGoReservationPhone: function() {
      report({
        eventName: 'click_go_reservation_phone',
        eventDescription: '点击手机号预约'
      });
    },
    /**
     * @param {string} [title] - 首页kv下载组件、首页侧边栏下载组件、内页侧边栏下载组件
     */
    scanDownloadGame: function(title) {
      report({
        eventName: 'scan_download_game',
        eventDescription: '扫码下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 首页kv下载组件、侧边浮窗下载组件
     */
    clickDownloadAndroid: function(title) {
      report({
        eventName: 'click_download_Android',
        eventDescription: '点击安卓下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 首页kv下载组件、侧边浮窗下载组件
     */
    clickDownloadIOS: function(title) {
      report({
        eventName: 'click_download_iOS',
        eventDescription: '点击苹果下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 首页kv下载组件、侧边浮窗下载组件
     */
    clickDownloadPC: function(title) {
      report({
        eventName: 'click_download_PC',
        eventDescription: '点击电脑下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickGoGw: function() {
      report({
        eventName: 'click_go_gw',
        eventDescription: '侧边浮窗点击进入官网'
      });
    },
    clickLianxikefu: function() {
      report({
        eventName: 'click_lianxikefu',
        eventDescription: '侧边浮窗点击联系客服'
      });
    },
    clickGoRecharge: function() {
      report({
        eventName: 'click_go_recharge',
        eventDescription: '点击官方充值'
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
